import { CandidateShareDetails } from "../../types/candidateShareDetails";
import { CandidateShareResponse } from "../controllers/candidates";

export const convertShareCandidateResponse = (
    response: CandidateShareResponse
): CandidateShareDetails => {
    const candidateShareDetails = new CandidateShareDetails();
    candidateShareDetails.emailUrl = response.emailUrl;
    candidateShareDetails.shortenedUrl = response.shortenedUrl;

    return candidateShareDetails;
};
